<template>
  <v-app>
    <v-app-bar
      app
      color="white"
    
    >
    <v-app-bar-nav-icon></v-app-bar-nav-icon>
     <h1>Todo App</h1>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
